/**
 * iRoll Variant Price Updater
 * Updates the Current Price block when variants change.
 * Works with the theme's variant picker by polling for checked option changes.
 */
(function() {
  'use strict';

  if (window.__irVariantPriceInitialized) return;
  window.__irVariantPriceInitialized = true;

  function formatPrice(cents) {
    return 'R ' + (cents / 100).toLocaleString('en-ZA');
  }

  function updatePrice(variantId) {
    if (!window.__irProductVariants) return;
    var variants = window.__irProductVariants;
    var selected = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id == variantId) {
        selected = variants[i];
        break;
      }
    }
    if (!selected) return;

    var priceEl = document.querySelector('.ir-early-roller [data-variant-price]');
    if (!priceEl) return;

    var newPrice = null;
    if (selected.metafields && selected.metafields.custom && selected.metafields.custom.xero_price_synced_variant && selected.metafields.custom.xero_price_synced_variant.value) {
      newPrice = selected.metafields.custom.xero_price_synced_variant.value;
    }
    if (!newPrice && window.__irProductMetafields && window.__irProductMetafields.custom && window.__irProductMetafields.custom.xero_price_synced_to_shopify) {
      newPrice = window.__irProductMetafields.custom.xero_price_synced_to_shopify.value;
    }
    if (!newPrice) return;

    var cents = Math.round(parseFloat(newPrice) * 100);
    if (isNaN(cents)) return;

    // Safety net (mirrors collection card): never display EFT at/above the
    // variant's card price — hide the whole block instead of showing a stale price.
    var blockEl = document.querySelector('.ir-early-roller');
    var cardCents = Math.round(parseFloat(selected.price) * 100);
    if (!isNaN(cardCents) && cardCents > 0 && cents >= cardCents) {
      if (blockEl) blockEl.style.display = 'none';
      return;
    }
    if (blockEl) blockEl.style.display = '';
    priceEl.textContent = formatPrice(cents);
  }

  // Poll the variant picker for checked option changes
  var lastCheckedVariantId = null;
  var pollInterval = setInterval(function() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var checked = picker.querySelector('fieldset input:checked');
    if (!checked) return;
    var variantId = checked.dataset.variantId;
    if (!variantId) return;
    if (variantId === lastCheckedVariantId) return;
    lastCheckedVariantId = variantId;
    var match = String(variantId).match(/(\d+)$/);
    if (match) variantId = match[1];
    updatePrice(variantId);
  }, 200);

  // Publish-cycle marker 2026-08-19 (asset resync)
  // Also listen for theme events
  document.addEventListener('variant:update', function(e) {
    if (e.detail && e.detail.resource && e.detail.resource.id) {
      var variantId = e.detail.resource.id;
      var match = String(variantId).match(/(\d+)$/);
      if (match) variantId = match[1];
      updatePrice(variantId);
    }
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', function() {
    clearInterval(pollInterval);
  });
})();
